// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MembershipDurationContainer{box-sizing:border-box;width:150px;padding-top:4px}.MembershipDurationContainer .feedbackSaveNotice{position:absolute;top:15px;right:0px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
